export default __webpack_public_path__ + "static/homepage-1b0694f41d041cbd3cd1be51c9c06719.svg";